<div class="monitors-admin-table">
	<div class="table-actions">
		<div class="actions-left">
			<!-- espacio para filtros futuros -->
		</div>
		<div class="actions-right">
			<button mat-flat-button color="primary" (click)="toggleAddForm()" [disabled]="showAddForm()"><mat-icon>add</mat-icon>&nbsp;Añadir monitor</button>
		</div>
	</div>

	@if (showAddForm()) {
	<div class="add-form">
		<h3>{{ mode === 'edit' ? 'Editar monitor' : 'Añadir monitor' }}</h3>
		<form [formGroup]="monitorForm" (ngSubmit)="saveMonitor()">
			<div class="form-row">
				<mat-form-field appearance="outline">
					<mat-label>Nombre</mat-label>
					<input matInput formControlName="name" />
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Corporate</mat-label>
					<mat-select formControlName="corporateId">
						@for (corp of dataCorporate(); track corp.id) {
						<mat-option [value]="corp.id">{{ corp.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>ClienteId</mat-label>
					<input matInput formControlName="clientId" />
				</mat-form-field>
				<mat-form-field appearance="outline">
					<mat-label>Regla</mat-label>
					<input matInput formControlName="ruleId" />
				</mat-form-field>
			</div>
			<div class="form-row">
				<mat-form-field class="full" appearance="outline">
					<mat-label>Descripción</mat-label>
					<input matInput formControlName="description" />
				</mat-form-field>
				<mat-checkbox formControlName="riskEvaluation">Evaluación de riesgo</mat-checkbox>
			</div>
			<div class="form-actions">
				<button mat-flat-button color="primary" type="submit" [disabled]="monitorForm.invalid"><mat-icon>save</mat-icon>&nbsp;Guardar</button>
				<button mat-button type="button" (click)="cancelAdd()"><mat-icon>close</mat-icon>&nbsp;Cancelar</button>
			</div>
		</form>
	</div>
	}


	<div class="table-wrapper">
		@if (dataSource() && dataSource().length) {
			<div class="table-container">
				<div class="thead-container">
					<table class="admin-table">
						<thead>
							<tr>
								<th>ID</th>
			                	<th>Nombre</th>
								<th>ClienteId</th>
								<th>Corporate</th>
								<th>Regla</th>
								<th>Evaluación Riesgo</th>
			                	<th>Descripción</th>
								<th>Acciones</th> 
								
							</tr>
						</thead>
					</table>
				</div>
				<div class="tbody-container">
					<table class="admin-table">
						<tbody>
							@for (monitor of dataSource(); track monitor.id) {
							<tr>
								<td class="col-id id-cell">
									<span class="id-text">{{ monitor.id }}</span>
									<button mat-icon-button class="copy-btn" (click)="copyId(monitor.id)" aria-label="Copiar ID" title="Copiar ID">
										<mat-icon>content_copy</mat-icon>
									</button>
								</td>
								<td>{{ monitor.name }}</td>			
								<td>{{ monitor.clientId }}</td>
								 <td>{{ getCorporateName(monitor.corporateId) }}</td> 
								 <td>{{ monitor.ruleId }}</td>
								<td>{{ monitor.riskEvaluation ? 'Sí' : 'No' }}</td>
			                	<td>{{ monitor.description }}</td>
								<td class="col-edit" style="text-align: center;">
									<button mat-stroked-button color="primary" class="action-btn" (click)="startEdit(monitor)">
										<mat-icon>edit</mat-icon>&nbsp;Editar
									</button>
								</td>
								<td class="col-create" style="text-align: center;">
									@if (!monitor.clientId || monitor.ruleId === null || monitor.ruleId === '') {
									<button mat-stroked-button color="accent" class="action-btn" (click)="createRule(monitor.id, monitor.clientId || '')">
										<mat-icon>rule</mat-icon>&nbsp;Crear regla
									</button>
									}
								</td>
							
							</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
		} @else {
		<div class="empty">No hay monitores para mostrar.</div>
		}
		</div>
</div>
 